import { Accordion, AccordionDetails, AccordionSummary, Grid, Radio, RadioProps, useTheme } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import IconButton from '@material-ui/core/IconButton'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import Slider from '@material-ui/core/Slider'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import clsx from 'clsx'
import moment from 'moment'
import React from 'react'
import { CompactPicker } from 'react-color'
import { FormattedMessage, useIntl } from 'react-intl'
import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'
import { IRootReduxState } from 'types/reducers'
import { WaoCheckboxProps, WaoDateTimeProps, WaoExpenderProps, WaoFormContainerProps, WaoMenuProps, WaoNumberFormatProps, WaoPhoneNumberProps, WaoSelectProps, WaoSliderProps, WaoStandardProps, WaoTextAreaProps,  WaoTimePickerProps } from './Forms.Interfaces'
import { KeyboardTimePicker,MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import MuiPhoneNumber from "material-ui-phone-number";
import { WaoDateOnly } from './WaoDateOnly'
export { WaoDateTime } from './WaoDateTime'
export { WaoDateOnly } from './WaoDateOnly'

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    panelHeading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    logo: {
      maxWidth: 150,
      maxHeight: 150,
    },
    header: {
      fontSize: '1.75em',
      fontWeight: 500,
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(2),
    },
    margins: {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(1),
    },
    outlinedLabel: {
      backgroundColor: theme.palette.background.paper,
      paddingLeft: 4,
      paddingRight: 4,
    },
    inlineMargins: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      display: 'inline-block',
    },
    colorPickerSwatch: {
      width: '14px',
      height: '14px',
      borderRadius: '2px',
    },
    swatch: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      padding: '5px',
      background: '#fff',
      borderRadius: '1px',
      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
      display: 'inline-block',
      cursor: 'pointer',
      verticalAlign: 'bottom',
    },
    wideLabel: {
      display: 'inline-flex',
      width: '100%',
    },
    popover: {
      position: 'absolute',
      zIndex: 1500,
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
    menu: {
      float: 'right',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
})

export const WaoFormContainer = ({ children, submit, style }: WaoFormContainerProps) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        event.stopPropagation()
        submit && submit(event)
        return false
      }}
      style={style}
    >
      {children}
    </form>
  )
}

export const WaoEmptyListPlaceholder = () => {
  const loading = useSelector((state: IRootReduxState) => state.app.state.loading)
  return (
    <div style={{ fontStyle: 'oblique', margin: '40px 20px' }}>
      {loading === 0 && <FormattedMessage id="empty-list" defaultMessage="Empty list. No results returned." />}
      {loading > 0 && <FormattedMessage id="loading" defaultMessage="loading..." />}
    </div>
  )
}

export const WaoExpander = ({ label, children, expanded = false, disabled = false }: WaoExpenderProps) => {
  const classes = useStyles()

  return (
    <Accordion defaultExpanded={expanded} disabled={disabled}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.panelHeading}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}

export const WaoHeader = ({ label }: WaoStandardProps) => {
  const classes = useStyles()
  return (
    <Typography variant="h4" className={classes.header}>
      {label}
    </Typography>
  )
}

export const WaoSubHeader = ({ label }: WaoStandardProps) => {
  const classes = useStyles()
  return (
    <Typography className={classes.margins} variant="subtitle1">
      {label}
    </Typography>
  )
}

export const WaoIntegerNumberFormat: React.FC<WaoNumberFormatProps> = ({ inputRef, onChange, ...props }: WaoNumberFormatProps) => {
  return (
    <NumberFormat
      {...props}
      decimalScale={0}
      isNumericString={true}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange && onChange({ target: { name: props.id, value: values.value } })
      }}
    />
  )
}

export const WaoPositiveIntegerNumberFormat: React.FC<WaoNumberFormatProps> = (props: WaoNumberFormatProps) => {
  return <WaoIntegerNumberFormat {...props} allowNegative={false} />
}
export const WaoPhoneNumber: React.FC<WaoPhoneNumberProps> = ({name, value, handleChange, handleBlur, label, ...props}:WaoPhoneNumberProps) =>{
  const classes = useStyles()
  return(
    <MuiPhoneNumber
      className={classes.margins}
      fullWidth
      id={name}
      label={label || name}
      value={value || ''}
      defaultCountry="us"
      {...props}
      onChange={(event) => {
        event.stopPropagation && event.stopPropagation()
        handleChange?.(name)(event)
      }}
      onBlur={(event) => {
        handleBlur?.(name)(event)
      }}
    />
  )
}
export const WaoText: React.FC<WaoStandardProps> = ({ name, value, handleChange, handleBlur, label, ...props }: WaoStandardProps) => {
  const classes = useStyles()
  const { defaultValue, ...inputProps } = props

  return (
    <TextField
      {...inputProps}
      className={classes.margins}
      fullWidth
      id={name}
      label={label || name}
      value={value || ''}
      onMouseDown={(event) => event.stopPropagation()}
      onChange={(event) => {
        event.stopPropagation && event.stopPropagation()
        handleChange?.(name)(event.target.value)
      }}
      onBlur={(event) => {
        handleBlur?.(name)(event.target.value)
      }}
    />
  )
}

export const WaoPositiveIntegerInput: React.FC<WaoStandardProps> = (props: WaoStandardProps) => {
  return <WaoText {...props} InputProps={{ inputComponent: WaoPositiveIntegerNumberFormat as any }} />
}

export const WaoIntegerInput: React.FC<WaoStandardProps> = (props: WaoStandardProps) => {
  return <WaoText {...props} InputProps={{ inputComponent: WaoIntegerNumberFormat as any }} />
}

export const WaoTextArea = ({ name, value, handleChange, label }: WaoTextAreaProps) => {
  const classes = useStyles()
  return <FormControlLabel label={label || name} control={<TextareaAutosize className={classes.margins} id={name} value={value} onChange={(event) => handleChange && handleChange(name)(event.target.value)} />} />
}

interface WaoRadioProps {
  radioValue: any
  radioLabel: string | JSX.Element
}
export const WaoRadio = (props: WaoRadioProps & RadioProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const radioColor = theme.palette.type === 'dark' ? '#60A5FA' : '#0F6EAA'
  const { radioValue, radioLabel, ...theRestOfTheProps } = props
  return <FormControlLabel classes={{ root: classes.wideLabel, label: classes.wideLabel }} className={classes.margins} value={radioValue} control={<Radio {...theRestOfTheProps} style={{ color: radioColor, ...theRestOfTheProps.style }} />} label={radioLabel} />
}

export const WaoCheckbox = ({ label, name, value, handleChange, disabled = false }: WaoCheckboxProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const checkboxColor = theme.palette.type === 'dark' ? '#60A5FA' : '#0F6EAA'
  return (
    <FormControlLabel
      classes={{ root: clsx(classes.margins, classes.wideLabel), label: classes.wideLabel }}
      label={label || name}
      control={
        <Checkbox
          disabled={disabled}
          checked={value || false}
          onChange={(event) => {
            handleChange && handleChange(name)(event.target.checked)
          }}
          name={name}
          style={{ color: checkboxColor }}
        />
      }
    />
  )
}

export const WaoDate = ({ name, value, handleChange, onChange, label = undefined, disabled = false, minDate, required }: WaoStandardProps & { onChange?: (v: string) => void; minDate?: string | Date }) => {
  return (
    <WaoDateOnly
      name={name}
      label={label || name}
      value={_toHtml5DateOnly(value?.toString())}
      disabled={disabled}
      minDate={minDate}
      required={required}
      onChange={(dateStr) => {
        if (handleChange) handleChange(name)(dateStr)
        if (onChange) onChange(dateStr)
      }}
    />
  )
}

//export const WaoDateTime = ({ name, value, handleChange, label = undefined, disabled = false }: WaoDateTimeProps) => {
//  const classes = useStyles()
//  return (
//    <TextField
//      className={classes.margins}
//      fullWidth
//      disabled={disabled}
//      type="datetime-local"
//      onChange={(event) => {
//        handleChange && handleChange(name)(event.target.value)
//      }}
//      InputLabelProps={{ shrink: true }}
//      id={name}
//      label={label || name}
//      value={_toHtml5Date(value)}
//    />
//  )
//}
export default function WaoTimePicker({name, value, handleChange, label, disabled = false}:WaoTimePickerProps) {
  const classes = useStyles();
  return (
     <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label={label}
              value={value}
              onChange={(event) => {
              handleChange&& handleChange(name)(event?event:new Date())}}
              KeyboardButtonProps={{
              'aria-label': 'change time',
              }}
              
            />
        </MuiPickersUtilsProvider>
  );
}

export const WaoSelect = ({ name, items, value, handleChange, label, ...props }: WaoSelectProps) => {
  const classes = useStyles()
  const inputLabel = React.useRef<HTMLLabelElement>(null)
  const [labelWidth, setLabelWidth] = React.useState(0)
  React.useEffect(() => {
    if (inputLabel && inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth)
    }
  }, [])
  const { variant, ...selectProps } = props as any
  return (
    <FormControl fullWidth variant={variant} className={classes.margins} required={props.required}>
      <InputLabel
        style={{ whiteSpace: 'nowrap' }}
        className={variant === 'outlined' ? classes.outlinedLabel : undefined}
        ref={inputLabel}
        htmlFor={name}
        shrink={variant === 'outlined' ? true : undefined}
      >
        {label || name}
      </InputLabel>
      <Select
        {...selectProps}
        labelWidth={variant === 'outlined' ? labelWidth : undefined}
        displayEmpty={variant === 'outlined'}
        MenuProps={{
          anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
          transformOrigin: { vertical: 'top', horizontal: 'left' },
          getContentAnchorEl: null,
          PaperProps: { style: { maxHeight: 300 } },
        }}
        value={value !== undefined ? value : ''}
        onChange={(event) => {
          handleChange && handleChange(name)(event.target.value)
        }}
        inputProps={{ name, id: name }}
      >
        {items.map((r) => (
          <MenuItem key={r.value} value={r.value}>
            {r.name}
            {r.detail && <br />}
            {r.detail}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export const WaoSlider = ({ name, label, value = 0, min = 0, max = 20, step = 1, handleChange }: WaoSliderProps) => {
  const classes = useStyles()
  return (
    <div className={classes.margins}>
      <Typography variant="caption" gutterBottom>
        {label || name}
      </Typography>
      <Slider
        name={name}
        defaultValue={value}
        getAriaValueText={(v) => v.toString()}
        min={min}
        max={max}
        step={step}
        onChange={(event, value) => {
          event.stopPropagation()
          handleChange && handleChange(name)(value)
        }}
        valueLabelDisplay="auto"
      />
    </div>
  )
}

export const WaoColourPicker = ({ name, label, value, handleChange }: WaoStandardProps) => {
  const classes = useStyles()
  const intl = useIntl()
  const [displayColorPicker, setDisplayColorPicker] = React.useState(false)
  const changeByTextField = (value: string) => {
    // make sure the string starts with an octothorpe
    if (value.length > 0 && value[0] !== '#') value = '#' + value
    // hex values are 7 characters long
    if (value.length > 7) value = value.substring(0, 7)
    handleChange && handleChange(name)(value)
  }
  // Fall back to a localized "Colour" label when no label is provided —
  // otherwise the TextField shows the raw `name` prop (e.g. "Color"), which
  // leaks an English string into German/French/Arabic/Chinese UIs.
  const resolvedLabel = label ?? intl.formatMessage({ id: 'common.color', defaultMessage: 'Colour' })
  return (
    <div>
      <TextField className={classes.inlineMargins} id={name} label={resolvedLabel} value={value || ''} onChange={(event) => changeByTextField(event.target.value)} />
      <div className={classes.swatch} onClick={() => setDisplayColorPicker(true)}>
        <div style={{ background: `${value || '#aaa'}` }} className={classes.colorPickerSwatch} />
      </div>
      {displayColorPicker && (
        <div className={classes.popover}>
          <div className={classes.cover} onClick={() => setDisplayColorPicker(false)} />
          <CompactPicker color={(value as string) || ''} onChange={(result) => handleChange && handleChange(name)(result.hex)} />
        </div>
      )}
    </div>
  )
}

export const WaoMenu = ({ items = [], onOpen }: WaoMenuProps) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<Element | undefined>(undefined)
  const [isOpen, setIsOpen] = React.useState<boolean>(false)

  const openMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    e.preventDefault()
    setAnchorEl(e.currentTarget)
    setIsOpen(true)
    onOpen && onOpen()
  }

  const handleItemClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, item) => {
    e.stopPropagation()
    if (!item.keepOpen) handleClose(e)
    item.click && item.click()
  }

  const handleClose = (e: {}) => {
    setAnchorEl(undefined)
    setIsOpen(false)
  }

  return (
    <React.Fragment>
      <IconButton aria-label="more" aria-controls="long-menu" aria-haspopup="true" className={classes.menu} onClick={(e) => openMenu(e)}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={isOpen === true}
        onClose={(e) => handleClose(e)}
        PaperProps={{
          style: {
            minWidth: 200,
          },
        }}
      >
        {items.map((item) => {
          return (
            <React.Fragment key={item.name}>
              {item.divider && <Divider />}
              <MenuItem onClick={(e) => handleItemClick(e, item)}>
                {item.control}
              </MenuItem>
            </React.Fragment>
          )
        })}
      </Menu>
    </React.Fragment>
  )
}

const _toHtml5Date = (val: Date | string | undefined): string => {
  if (val === undefined) return ''
  if (val instanceof Date) val = val.toLocaleDateString()

  const m = moment(val)
  return m.isValid() ? m.format(moment.HTML5_FMT.DATETIME_LOCAL) : ''
}

const _toHtml5DateOnly = (val: string | undefined): string => {
  if (val === undefined) return ''
  const m = moment(val)
  return m.isValid() ? m.format(moment.HTML5_FMT.DATETIME_LOCAL).substring(0, 10) : ''
}
